/**
 * Motion helpers for the toy shell.
 *
 * `prefersReducedMotion()` is queried AT THE MOMENT of the gesture (not cached):
 * the system setting can change while the app is open. Guard for
 * environments without matchMedia (jsdom).
 */

export function prefersReducedMotion(): boolean {
  // Widen to `| undefined`: jsdom/tests do not implement matchMedia.
  const matchMedia = globalThis.matchMedia as typeof globalThis.matchMedia | undefined;
  return matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
}

/** Duration of the object's "boing" before it travels to its module (ms). */
export const TOY_LAUNCH_MS = 240;

/** Duration of the squash-and-stretch bounce animation (ms). */
export const TOY_BOUNCE_MS = 460;
